/* unplugin-vue-components disabled */import { render } from "./regist.vue?vue&type=template&id=5744b8e3&scoped=true"
import script from "./regist.vue?vue&type=script&lang=js"
export * from "./regist.vue?vue&type=script&lang=js"

import "./regist.vue?vue&type=style&index=0&id=5744b8e3&lang=stylus&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5744b8e3"]])

export default __exports__